// VINEY brand pages and the product page brand note (interaction rules session 5b, rule 6 and rule 11; T679).
// Loaded (defer) by sections/vn-brand-head.liquid (brand pages) and snippets/vn-brand-note.liquid (every product page).
//   1. Page to page (rule 11): the brand header's plate carries view-transition-name vm-{handle} in the HTML, so a
//      plate tapped on Vörumerki (assets/vn-vorumerki.js names it on tap) lands on it. When this page is left, the
//      name comes off: one named element per page, and no other page has this plate to travel to.
//   2. The "Á tilboði" chip (snippets/vn-brand-chip.liquid): filters the grid in the page; a card stays when its
//      product is one the facts counted (data-ids). Cards added later (infinite scroll) and a grid Horizon
//      re-renders are filtered as they arrive. Horizon re-renders the section from the server on a sort or
//      filter, which turns the chip off with its cards in step.
//   3. The product page brand note (snippets/vn-brand-note.liquid): puts in the sentence from the answer its
//      inline script asked for (sections/vn-bn-facts.liquid); no sentence, a failed request or an answer
//      that cannot be read, and the note is not there. A box held for a sale product closes then, and when
//      the sentence is shorter than the box held for it, the box keeps its height (nothing below moves up).
//      Mark: data-vn-bn 'ok' | 'none' | 'fail'.
(() => {
  // ---- 1. the plate's name, only for the trip in
  const plate = document.querySelector('[data-vn-bh-plate]');
  if (plate) {
    window.addEventListener('pageswap', () => { plate.style.viewTransitionName = 'none'; });
    // back from the back/forward cache: the plate may travel in again from Vörumerki
    window.addEventListener('pageshow', (e) => { if (e.persisted) plate.style.viewTransitionName = ''; });
  }

  // ---- 2. the chip
  const CHIP = '[data-vn-sale-chip]';
  const apply = () => {
    const chip = document.querySelector(CHIP);
    const on = !!chip && chip.getAttribute('aria-pressed') === 'true';
    // off with nothing hidden (every load and grid change of a page whose chip is off): nothing to do (speed)
    if (!on && !document.querySelector('.vn-bh-x')) return;
    const ids = new Set(on ? (chip.dataset.ids || '').split(' ').filter(Boolean) : []);
    document.querySelectorAll('.product-grid__item[data-product-id]').forEach((li) => {
      li.classList.toggle('vn-bh-x', on && !ids.has(li.dataset.productId || ''));
    });
  };
  // on every brand page (this script is loaded by the brand header), not only when a chip is there at load: a chip
  // Horizon brings in later (a filter cleared on a page opened filtered) works the same (verification round 1)
  if (plate || document.querySelector(CHIP)) {
    document.addEventListener('click', (e) => {
      const chip = /** @type {Element} */ (e.target).closest?.(CHIP);
      if (!chip) return;
      const on = chip.getAttribute('aria-pressed') !== 'true';
      chip.setAttribute('aria-pressed', String(on));
      chip.classList.toggle('vn-bh-chip--on', on);
      apply();
    });
    // S11 Sale-day prices: the chip rests while html[data-vn-sp] is on: a filter it had set must not stay with no way out
    document.addEventListener('vn:ev', () => {
      const chip = document.querySelector(CHIP);
      if (chip && document.documentElement.hasAttribute('data-vn-sp') && chip.getAttribute('aria-pressed') === 'true') /** @type {HTMLElement} */ (chip).click();
    });
    const list = document.querySelector('results-list');
    if (list) {
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => { queued = false; apply(); });
      }).observe(list, { childList: true, subtree: true });
    }
  }

  // ---- 3. the product page note: one routine (verification rounds 1-2 found three edges of a morph; redesigned)
  // Horizon morphs the product section from server HTML on some variant changes (a connected product's option
  // re-renders <main>): the note may then be a new element, the same element with another product's address, or
  // appear on a page that opened without one, and an answer for the previous product may still be on its way.
  // So: the words are asked for once per product address (data-u) and cached; sync() fills whichever note is on the
  // page now, at load and whenever a note arrives or changes (a mutation observer); an answer is put in only while the note still waits and
  // still names the product it was asked for. This script is on every product page, note or not.
  const put = (/** @type {HTMLAnchorElement} */ n, /** @type {string} */ t, /** @type {string} */ mark) => {
    const held = n.classList.contains('vn-bn--hold');
    const h0 = held ? n.getBoundingClientRect().height : 0;
    const w0 = held ? n.getBoundingClientRect().width : 0;
    const tx = n.querySelector('.vn-bn__t');
    if (tx) { tx.textContent = t; tx.removeAttribute('data-ph'); }
    n.classList.remove('vn-bn--hold');
    n.style.visibility = '';
    n.hidden = !t;
    n.dataset.vnBn = mark;
    // shorter than the box held for it: keep the height while the width is the same (nothing below moves up)
    if (t && h0 && n.getBoundingClientRect().height < h0) {
      n.style.minHeight = `${h0}px`;
      const ro = new ResizeObserver(() => {
        if (Math.abs(n.getBoundingClientRect().width - w0) > 1) { n.style.minHeight = ''; ro.disconnect(); }
      });
      ro.observe(n);
    }
  };
  const read = (/** @type {Promise<string | null>} */ answer) => answer.then((text) => {
    let t = null;
    const m = /<script[^>]*data-vn-bn-json[^>]*>([\s\S]*?)<\/script>/.exec(text || '');
    try { const d = m ? JSON.parse(m[1]) : null; if (d && typeof d.t === 'string') t = d.t; } catch {}
    return { t: t || '', mark: t === null ? 'fail' : t ? 'ok' : 'none' };
  });
  /** @type {Map<string, Promise<{t: string, mark: string}>>} */
  const asked = new Map();
  // the page's own answer, asked for by its inline script while the page was still loading
  const first = /** @type {any} */ (window).vnBnFacts;
  if (first && first.u && first.a) asked.set(first.u, read(first.a));
  const ask = (/** @type {string} */ u) => {
    if (!asked.has(u)) asked.set(u, read(fetch(`${u}?section_id=vn-bn-facts`).then((r) => (r.ok ? r.text() : null)).catch(() => null)));
    return /** @type {Promise<{t: string, mark: string}>} */ (asked.get(u));
  };
  let marked = false;
  const sync = () => {
    const n = /** @type {HTMLAnchorElement | null} */ (document.querySelector('[data-vn-bn]'));
    if (!n || n.dataset.vnBn !== 'wait' || !n.dataset.u) return;
    const u = n.dataset.u;
    ask(u).then((s) => {
      if (!marked) { marked = true; try { performance.mark(s.mark === 'fail' ? 'vn-bn-fail' : 'vn-bn'); } catch {} }
      if (n.isConnected && n.dataset.u === u && n.dataset.vnBn === 'wait') put(n, s.t, s.mark);
    });
  };
  sync();
  // when: watched, not told (round 3: when a morph replaces the variant picker itself, Horizon dispatches variant:update
  // from the detached old picker and no document listener hears it). Any note that arrives or changes its address or
  // its state is filled; the work per change is one look-up, and put() itself ends at a state sync() leaves alone.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; sync(); });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-vn-bn', 'data-u'] });
})();
